import { Navigate, useLocation, useParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
    <Loader2 className="text-[#A78BFA] animate-spin" size={28} />
  </div>
);

/**
 * Slug-aware protected route.
 * - `roles` (array) is matched against `user.role`.
 * - When not authenticated, redirects to the tenant login (`/:slug/login`)
 *   or to a `fallback` URL if provided (e.g. `/admin/login`).
 * - When wrong role, redirects to the user's natural landing page.
 */
export const ProtectedRoute = ({ children, roles, fallback }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const { slug } = useParams();

  if (loading) return <Loading />;

  if (!user) {
    const target = fallback || (slug ? `/${slug}/login` : "/");
    return <Navigate to={target} state={{ from: location.pathname }} replace />;
  }

  // collegata a un altro centro: si passa dalla pagina di accesso di questo
  if (slug && user.role !== "super_admin" && user.tenant_slug
      && user.tenant_slug !== String(slug).toLowerCase()) {
    return <Navigate to={`/${slug}/login`} state={{ from: location.pathname }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    let target = "/";
    if (user.role === "super_admin") target = "/admin";
    else if (user.role === "client") target = slug ? `/${slug}/app` : "/";
    else if (user.role === "staff" || user.role === "admin")
      target = slug ? `/${slug}/staff` : "/";
    return <Navigate to={target} replace />;
  }

  return children;
};
